import { Flex } from 'antd';

import { ConditionView, ServiceRowCard, ServiceRowCardVariant } from '@/shared/ui';

import { UserRequest } from '@/api/types';

import { UserRequestsTab } from '../model';

interface Props {
  tab: UserRequestsTab;
  userRequests: UserRequest[];
  storeDeletedUserRequest: (userRequest: UserRequest['id']) => void;
}

export const UserRequestsList: React.FC<Props> = ({ tab, userRequests, storeDeletedUserRequest }) => {
  return (
    <Flex vertical gap={16} className="user-requests-list">
      {userRequests.map((userRequest) => (
        <ConditionView
          key={userRequest.id}
          if={tab === 'draft'}
          else={<ServiceRowCard variant={ServiceRowCardVariant.USER_REQUEST} userRequest={userRequest} />}
        >
          <ServiceRowCard
            variant={ServiceRowCardVariant.USER_REQUEST_DRAFT}
            data={{
              id: userRequest.id,
              title: userRequest.title,
              createdAt: userRequest.created_at,
              updatedAt: userRequest.updated_at,
              currentStep: userRequest.meta?.current_step ?? 0,
              totalSteps: userRequest.meta?.total_steps ?? 0,
              serviceCode: userRequest.service_code,
            }}
          />
        </ConditionView>
      ))}
    </Flex>
  );
};
